declare global {
  interface Window {
    WHITE_BOT_CONFIG?: Partial<RuntimeConfig>;
  }
}

export interface RuntimeConfig {
  apiMode: 'mock' | 'supabase';
  supabaseUrl: string;
  supabaseAnonKey: string;
}

export function runtimeConfig(): RuntimeConfig {
  const w = window.WHITE_BOT_CONFIG || {};
  return {
    apiMode: w.apiMode || (import.meta.env.VITE_API_MODE as RuntimeConfig['apiMode']) || 'mock',
    supabaseUrl: w.supabaseUrl || import.meta.env.VITE_SUPABASE_URL || '',
    supabaseAnonKey: w.supabaseAnonKey || import.meta.env.VITE_SUPABASE_ANON_KEY || ''
  };
}
